import ProgressBar from 'components/layout/ProgressBar';
import useEnquiryProgressBar from './useEnquiryProgressBar';

const EnquiryProgressBar: React.FunctionComponent = function () {
  const { steps } = useEnquiryProgressBar();
  if (!steps) return undefined;
  return (
    <div className="block lg:hidden">
      <ProgressBar steps={steps} />
    </div>
  );
};

export default EnquiryProgressBar;
